var map = {
	"./BG1.1.png": 28,
	"./BG1.png": 37,
	"./BG2.1.png": 29,
	"./BG2.png": 38,
	"./Campfire.2.png": 39,
	"./Campfire.3.png": 27,
	"./Campfire.png": 40,
	"./blackjack.png": 41,
	"./c2.png": 42,
	"./c3.png": 43,
	"./c4.png": 44,
	"./c5.png": 45,
	"./c6.png": 46,
	"./c7.png": 47,
	"./c8.png": 30,
	"./couvRavage1.png": 48,
	"./couvRavage2.png": 49,
	"./drum_machine.png": 50,
	"./markdownpreviewer.png": 51,
	"./pomodoroclock.png": 52,
	"./profilepic.png": 31,
	"./simon.png": 53,
	"./tictactoe.png": 54
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*\.png$
// module id = 36
// module chunks = 0